<mat-accordion multi="true">
  <ng-container *ngFor="let group of libraryGroups; let i = index">
    <mat-expansion-panel
      *ngIf="group.type === 'group'"
      class="library-group"
      (opened)="expandedGroups[group.id] = true"
      (closed)="expandedGroups[group.id] = false"
      [expanded]="expandedGroups[group.id] && countVisibleProjects(group.children) > 0"
      [disabled]="countVisibleProjects(group.children) < 1"
    >
      <mat-expansion-panel-header class="mat-expansion-panel-header--lg">
        <div class="library-group__title flex flex-col">
          <div>{{ group.name }}</div>
          <div class="mat-caption">
            {{ countVisibleProjects(group.children) }} <ng-container i18n>unit(s)</ng-container>
          </div>
        </div>
        <app-library-group-thumbs [group]="group" [ngClass]="{ hide: expandedGroups[group.id] }" />
      </mat-expansion-panel-header>
      <div class="flex flex-col flex-wrap items-start sm:flex-row">
        <ng-container *ngFor="let project of group.children">
          <div *ngIf="project.visible" class="w-full sm:w-1/2 md:w-1/2 lg:w-1/3">
            <app-library-project [project]="project" />
          </div>
        </ng-container>
      </div>
    </mat-expansion-panel>
  </ng-container>
</mat-accordion>
